const Tabs = (props) => {
  const { id, isActive, name, onClick, isStrong = true } = props;

  return (
    <div
      className={`${id === isActive ? "is-active" : ""} tab mr-1`}
      style={{
        fontWeight: !isStrong ? 400 : "",
      }}
      onClick={onClick}
    >
      {name}
    </div>
  );
};

export default Tabs;
